import {AfterViewInit, Component, computed, ElementRef, ViewChild} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {debounceTime, fromEvent} from 'rxjs';
import {filter, tap} from 'rxjs/operators';
import {Campaign, CampaignLocationsListComponent} from 'shared-lib';
import {LoyaltyCampaignsStore} from '../../../store/paged-campaigns.store';

@Component({
  template: '',
  standalone: false
})
export abstract class CampaignsListComponentComponent implements AfterViewInit {
  @ViewChild('actionPreviewContainer') containerRef?: ElementRef;
  store = computed(() => this.getStore());

  protected constructor(private bottomSheet: MatBottomSheet) {
  }

  protected abstract getStore: () => LoyaltyCampaignsStore;

  ngAfterViewInit() {
    this.setupScrollListener();
  }

  loadLocations(campaignId: string): void {
    this.store().loadLocations(campaignId);
  }

  openValueRatingModal() {
    // this.bottomSheet.open(ValueRatingSlideInComponent);
  }

  openHowToRedeemModal(campaign: Campaign) {
  }

  openViewLocations(campaign: Campaign): void {
    this.bottomSheet.open(CampaignLocationsListComponent, {
      data: campaign
    })
  }

  private setupScrollListener(): void {
    fromEvent(window, 'scroll')
      .pipe(
        debounceTime(100),
        filter(() => this.store().hasMorePages()),
        filter(() => !this.store().isLoading()),
        filter(() => this.isScrollNearBottom()),
        tap(() => {
          this.store().nextPage();
        })
      )
      .subscribe();
  }

  private isScrollNearBottom(): boolean {
    const container = this.containerRef?.nativeElement;
    if (!container) {
      return false;
    }
    const scrollPosition = container.scrollTop + container.clientHeight;
    const threshold = container.scrollHeight - 300;
    return scrollPosition >= threshold;
  }
}
